// extracted by mini-css-extract-plugin
module.exports = {"label":"fields-module--label--1DqPJ","checkbox":"fields-module--checkbox--W8HkP"};